import client from '@/api/AxiosInstance.js'
export default {
  getApi() {
    return client.get('')
  },

  register(params) {
    return client.post('/auth/register', {
      name: params.name,
      phone_number: params.phone_number,
      dob: params.dob,
      // province_of_work: params.province_of_work,
      // province_of_resident: params.province_of_resident,
      income_type: params.income_type,
      salary: params.salary,
      email: params.email,
    })
  },

  registerWithPhone(params) {
    return client.post('/auth/register-only-phone-no', {
      phone_number: params.phone_number,
      identity_number: params.identity_number,
      passport: params.passport,
      work_permit: params.work_permit,
      father_name: params.father_name,
      status: 'active',
    })
  },

  getOTP(params) {
    return client.post('/auth/send-otp', {
      phone_number: params.phone_number,
      forget_password: params.forget_password,
    })
  },

  login(params) {
    return client.post('/auth/login', {
      phone_number: params.phone_number,
      type: params.type, // pincode | otpcode
      code: params.code,
      forget_password: params.forget_password,
    })
  },

  setPassword(params) {
    return client.post('/auth/set-password', {
      phone_number: params.phone_number,
      password: params.password,
      forget_password: params.forget_password,
      auth_token: params.auth_token,
    })
  },

  getUserProfile() {
    return client.get('/profile')
  },

  updateProfile(params) {
    return client.post('/profile', {
      name: params.name,
      phone_number: params.phone_number,
      dob: params.dob,
      // province_of_work: params.province_of_work,
      // province_of_resident: params.province_of_resident,
      income_type: params.income_type,
      salary: params.salary,
      email: params.email,
      identity_number: params.identity_number,
      passport: params.passport,
      work_permit: params.work_permit,
      province_id: params.province_id,
      branch_id: params.branch_id,
    })
  },

  getOTPToChangePhone(params) {
    return client.post('/change-number/send-otp', {
      phone_number: params.phone_number,
    })
  },

  changePhoneNumber(params) {
    return client.post('/change-number', {
      phone_number: params.phone_number,
      code: params.code,
    })
  },

  destoryCache(params) {
    return client.post('/auth/destory-cache', {
      phone_number: params.phone_number,
    })
  },

  checkOTP(params) {
    return client.post('/auth/check-otp', {
      phone_number: params.phone_number,
      code: params.code,
      forget_password: params.forget_password,
    })
  },

  setLanguage() {
    return client.post('/auth/set-lang')
  },

  checkPinCode(params) {
    return client.post('/auth/check-pin-code', {
      password: params.password,
    })
  },

  checkBlackedListedUser(params) {
    return client.get('data/check-blacklisted-user', {
      params: params,
    })
  },
}
